import { privatePolicyResponse, useGetPrivatePolicy } from "@/app/api"
import { RootState } from "@/app/store"
import sanitizeHtml from "sanitize-html"

export default function PrivatePolicy() {
  const t = useTranslate()
  const lang = useAppSelector((state: RootState) => state.app.lang)
  const getPrivatePolicy = useGetPrivatePolicy()

  const [privatePolicyResponse, setPrivatePolicy] =
    useState<privatePolicyResponse | null>(null)

  useEffect(() => {
    ;(async () => {
      const res = await getPrivatePolicy(lang)
      setPrivatePolicy(res)
    })()
  }, [lang])

  return (
    privatePolicyResponse && (
      <>
        <div className="body">
          <div className="receipt">
            <p className="text1 text-left">{t("privatePolicy.title")}</p>
            <p
              className="text2 text-left whitespace-pre-line"
              dangerouslySetInnerHTML={{
                __html: sanitizeHtml(privatePolicyResponse.privatePolicy),
              }}
            ></p>
          </div>
        </div>
      </>
    )
  )
}
